import { render, staticRenderFns } from "./CommercialView.vue?vue&type=template&id=7f7d7d15&scoped=true"
import script from "./CommercialView.vue?vue&type=script&lang=js"
export * from "./CommercialView.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=7f7d7d15&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d7d15",
  null
  
)

export default component.exports